'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _ModuleManager = require('./ModuleManager');

var _ModuleManager2 = _interopRequireDefault(_ModuleManager);

var _ModuleReducer = require('./ModuleReducer');

var _Store = require('../../services/Store');

var _InitializeModuleSaga = require('./sagas/InitializeModuleSaga');

var _InitializeModuleSaga2 = _interopRequireDefault(_InitializeModuleSaga);

var _OnAuthenticationSuccessAction = require('../../components/module/actions/OnAuthenticationSuccessAction');

var _OnAuthenticationSuccessAction2 = _interopRequireDefault(_OnAuthenticationSuccessAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    moduleId: (0, _ModuleReducer.getModuleId)(state.module),
    isReady: (0, _ModuleReducer.getIsReady)(state.module),
    isStandalone: (0, _ModuleReducer.getIsStandalone)(state.module),
    isAuthenticated: (0, _ModuleReducer.getIsAuthenticated)(state.module),
    reactIntlDefaultLocale: (0, _ModuleReducer.getReactIntlDefaultLocale)(state.module),
    locale: (0, _ModuleReducer.getLocale)(state.module),
    site: (0, _ModuleReducer.getSite)(state.module)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onWillMount: function onWillMount() {
      (0, _Store.runSaga)(_InitializeModuleSaga2.default);
    },
    onAuthenticationSuccess: function onAuthenticationSuccess(authData) {
      dispatch((0, _OnAuthenticationSuccessAction2.default)(authData.memberHash, authData.memberId, authData.companyName, authData.site));
    }
  };
};

var ModuleManagerContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ModuleManager2.default);

exports.default = ModuleManagerContainer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/module/ModuleManagerContainer.js
// module id = 333
// module chunks = 10